<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
      <!-- Optional: Override stats slot for audio-specific formatting -->
      <!-- Using default for now, but can be customized here -->
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// This replaces the old manual JSON parsing + lazy fallbacks pattern
// If config is invalid, parseAndValidateConverterConfig() throws with detailed error
// NOTE: jobCategory, labels, and creditCost are now provided by backend
const converterConfig = parseAndValidateConverterConfig('paf-to-mp3-converter', 'PAF → MP3');

// Event handlers (optional - for audio-specific analytics or side effects)
function handleBatchCreated(batchId: string) {
  console.log('[PAF-to-MP3 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[PAF-to-MP3 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[PAF-to-MP3 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[PAF-to-MP3 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[PAF-to-MP3 Converter] Credits updated:', credits);
}
</script>
